(ns app.front.view.group.admin.property.config.attachments
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.attachment-type-config :as at-config]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.core :as acore]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-fx ::save-config.success
  (fn [_ [_ on-success status resp]]
    {:dispatch-n [[::entities/apply-changes status resp]
                  [:notifications/add :toast :success :success ""]
                  (when on-success
                    (on-success resp))]}))


(rf/reg-event-fx ::save-property-attachment-config
  (fn [_ [_ group-id attachment-type-ids on-success]]
    {:fx [[:dispatch [:comm/command-monitored {:command    :group/set-property-attachment-config
                                               :method     :post
                                               :data       (util/mmap group-id attachment-type-ids)
                                               :on-success [::save-config.success on-success]}]]]}))


(defn do-save-property-config [id attribute-value-map]
  (rf/dispatch [::save-property-attachment-config
                id
                (-> attribute-value-map :group/available-property-attachments set)
                nil]))


(defn attachments-content []
  (let [tr                  (<sub [::gas/group-tr])
        group-id            (<sub [::gas/group-id])
        group               (<sub [::gas/group])
        loading?            (<sub [::acore/fetching-config? group-id :group/attachment-types])
        default-attachments (set (entities/get-id group :group/available-property-attachments))]
    [acommon/config-section
     (tr [:group-admin/attachments-title])
     [:p.admin-page__instruction.bx--col-bx-12.whitespace-pre-line (tr [:property-mgmt-config/attachment-instruction])]
     (r/with-let [*selected-attachments (r/atom {group-id default-attachments})]
       [acommon/admin-config-form
        [at-config/available-attachments-editor
         tr
         nil
         group-id
         {:save-fn                  do-save-property-config
          :available-attachments-kw :group/available-property-attachments
          :default-attachments      default-attachments
          :kind                     :attachment-type.kind/property
          :loading?                 loading?}
         *selected-attachments]])]))
